"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function ModalBody(props) {
    return jsx_runtime_1.jsx(Box_1.Box, Object.assign({}, props), void 0);
}
exports.ModalBody = ModalBody;
//# sourceMappingURL=index.js.map